import { render, staticRenderFns } from "./StepNavigation.vue?vue&type=template&id=038f12b8&scoped=true"
import script from "./StepNavigation.vue?vue&type=script&lang=js"
export * from "./StepNavigation.vue?vue&type=script&lang=js"
import style0 from "./StepNavigation.vue?vue&type=style&index=0&id=038f12b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "038f12b8",
  null
  
)

export default component.exports